exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[class*=lang-] script[type=\"text/plain\"],[class*=language-] script[type=\"text/plain\"],script[type=\"text/plain\"][class*=lang-],script[type=\"text/plain\"][class*=language-]{display:block;font:100% Consolas,Monaco,monospace;white-space:pre;overflow:auto}", ""]);

// exports
